import clsx from "clsx";
import { BackIcon } from "@/components/RFIcon";
import { cn } from '@/lib/utils'
import { CSSProperties, ReactNode } from 'react'

interface SelectWrapperProps {
	placeholder?: string;
	text?: string;
	style?: CSSProperties;
	labelLeft?: ReactNode | string;
	onClick?: () => void;
	disabled?: boolean;
	className?: string;
	iconClassName?: string;
}

export default function SelectHolder({
	text,
	style,
	labelLeft,
	onClick,
	placeholder = "请选择",
	disabled,
	className,
	iconClassName
}: SelectWrapperProps) {
	return (
		<div
			className={cn(
				"flex h-12 items-center gap-4 rounded-full py-3 pl-5 pr-5 font-bold cursor-pointer",
				className,
				disabled ? "rf-select-normal" : "rf-select-normal__active",
			)}
			style={{ ...style }}
			onClick={() => onClick && onClick()}
		>
			<div className="flex flex-1 items-center">
				{labelLeft}
				{text ? <span className="font-semibold">{text}</span> : <span className="c3_85_text">{placeholder}</span>}
			</div>

			{disabled ? null : <BackIcon strokeWidth={2} className={cn('text-c3c3c3 dark:text-858585/80 -rotate-90 w-3.5 mt-1', iconClassName)} />}
		</div>
	);
}
